import { Injectable } from '@angular/core';
import { Pagination } from '../../models/base';
import {
  UserOrder,
  UserOrderItem,
  UserShippingAddress,
} from '../../models/shopping';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class AccountApiService {
  constructor(private http: HttpService) {}

  buildurl(path: string, queryMap: any = null): string {
    return this.http.buildurl('/account' + path, queryMap);
  }

  findUserShippingAddresses(): Promise<UserShippingAddress[]> {
    const url = this.buildurl('/addresses');
    return this.http.fget(url);
  }

  createUserShippingAddress({
    fname,
    lname,
    line1,
    line2,
    city,
    state,
    country,
    postal_code,
  }: {
    fname: string;
    lname: string;
    line1: string;
    line2: string;
    city: string;
    state: string;
    country: string;
    postal_code: string;
  }): Promise<UserShippingAddress> {
    const url = this.buildurl('/address');
    const body = {
      fname,
      lname,
      line1,
      line2,
      city,
      state,
      country,
      postal_code,
    };
    return this.http.post(url, body);
  }

  updateUserShippingAddress(
    id: number,
    {
      fname,
      lname,
      line1,
      line2,
      city,
      state,
      country,
      postal_code,
    }: {
      fname: string;
      lname: string;
      line1: string;
      line2: string;
      city: string;
      state: string;
      country: string;
      postal_code: string;
    }
  ): Promise<UserShippingAddress> {
    const url = this.buildurl(`/address/${id}`);
    const body = {
      fname,
      lname,
      line1,
      line2,
      city,
      state,
      country,
      postal_code,
    };
    return this.http.put(url, body);
  }

  deleteUserShippingAddress(id: number): Promise<void> {
    const url = this.buildurl(`/address/${id}`);
    return this.http.delete(url);
  }

  findUserOrders({
    qurey,
    status,
    page,
    page_size,
  }: {
    qurey?: string;
    status?: string;
    page?: number;
    page_size?: number;
  }): Promise<Pagination<UserOrder>> {
    const url = this.buildurl(`/orders`, { qurey, status, page, page_size });
    return this.http.fget(url);
  }

  findUserOrderItems(id: string): Promise<UserOrderItem[]> {
    const url = this.buildurl(`/order/${id}/items`);
    return this.http.fget(url);
  }
}
